import React, { useEffect, useState } from 'react';
import {
  Form,
  //   Checkbox,
  Select,
  Row,
  Col,
  Typography,
  Input,
  Button,
  Radio,
  Progress,
  message,
  Tag,
  InputNumber
  // InputNumber
} from 'antd';
import styles from './styles.module.less';
import { useDispatch, useSelector } from 'react-redux';
import { useParams, useNavigate } from 'react-router-dom';
// import LeftImg from '@/common/assets/images/LeftImg1.png';
// import downloadIcon from '@/common/assets/images/DownloadIcon.svg';
// import EditIcon from '@/common/assets/images/EditIcon.svg';

import { editpartnerdetails } from '../redux/slice';
import { event } from '../../../utilities/gtag';

const { Text } = Typography;
// const { Option } = Select;
const { TextArea } = Input;
const Edit = ({
  // country_codes,
  // state_details,
  city_details,
  family_Status,
  family_Value,
  family_Type,
  education_list,
  currency_data,
  user_data
}) => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [familyStatus, setFamilyStatus] = useState();
  const [familyValue, setFamilyValue] = useState();
  const [familyType, setFamilyType] = useState();
  const [cityes, setCityes] = useState('');
  const [minAge, setMinAge] = useState(18);
  const [minHeight, setMinHeight] = useState(100);
  const [annualIncome, setAnnualIncome] = useState('');
  console.log('cityes', cityes);

  const { editpartnerdetailsloading } = useSelector(
    (state) => state.editpartner
  );

  const params = useParams();
  //   console.log('education_list', education_list);
  console.log('Profile_ID:', params.id);

  const onFinish = async (values) => {
    // console.log('Edit_DesiredPartner', values);
    event({
      action: 'profile_creation', // event name
      category: 'Desired Partner Creation',
      label: 'Profile Form Submitted',
      value: 1
    });

    const payload = {
      profile_id: params.id,
      min_age: values.minAge,
      max_age: values.maxAge,
      min_height: values.minHeight,
      max_height: values.maxHeight,
      currency_code_id: values.currency,
      annual_income: values.annual_income,
      // country_id: values.country,
      // city_id: values.city,
      family_status_id: values.family_status_id,
      family_values_id: values.family_values_id,
      family_type_id: values.family_type_id,
      partner_description: values.describepartner,
      partner_education_id: values.highestEducation,
      partner_father_education_id: values.partner_father_education_id,
      partner_mother_education_id: values.partner_mother_education_id,
      desired_cities: values.city.map((cityId) => ({ desired_city_id: cityId }))
    };

    console.log('Payload_Horoscope', payload);
    try {
      console.log('Form Submitted:', payload);
      const response = await dispatch(editpartnerdetails(payload)).unwrap(); // Dispatch Redux action
      if (response?.success) {
        localStorage.setItem('profile_id', response.profile_id); // Store profile ID
        // navigate(`/membership_payment/${response.profile_id}`); // Redirect on success
        message.success(response.message || 'Form submitted successfully!');
        navigate(`/membership_payment`);
      }
    } catch (error) {
      console.error('Error submitting form:', error);
      message.error(
        error?.message || 'Failed to submit the form. Please try again.'
      );
    }
  };

  // const [form] = Form.useForm();
  // Tabs Data //
  const routes = {
    'About Me': '/editprofile',
    'Family Details': '/editfamily',
    'Education & Career': '/editeducation',
    Horoscope: '/edithoroscope',
    Contact: '/editcontact',
    'Desired Partner': '/editpartner',
    Membership: '/membership_payment'
  };
  const handleSectionClick = (section) => {
    if (routes[section]) {
      navigate(routes[section]);
    }
  };
  const activeTab = Object.entries(routes).find(
    ([, path]) => location.pathname === path
  )?.[0];

  // Tabs Data

  const matUserData = localStorage.getItem('MAT-User');
  const matUserObject = JSON.parse(matUserData);
  const userName =
    matUserObject.user_details.first_name +
    ' ' +
    matUserObject.user_details.last_name;

  useEffect(() => {
    if (user_data?.Profiles?.[0]) {
      const desiredPartner_details = user_data?.Profiles?.[0];

      setFamilyStatus(
        desiredPartner_details?.ProfileDesiredPartners?.[0]?.FamilyStatus?.id
      );
      setFamilyValue(
        desiredPartner_details?.ProfileDesiredPartners?.[0]?.FamilyValue?.id
      );
      setFamilyType(
        desiredPartner_details?.ProfileDesiredPartners?.[0]?.FamilyType?.id
      );

      const educationData =
        user_data?.Profiles?.[0]?.ProfileDesiredPartners?.[0]?.p_edu;
      const parent_mather_educationData =
        user_data?.Profiles?.[0]?.ProfileDesiredPartners?.[0]?.p_mother_edu?.id;
      const partner_father_educationData =
        user_data?.Profiles?.[0]?.ProfileDesiredPartners?.[0]?.p_father_edu?.id;
      console.log('parent_mather_educationData', parent_mather_educationData);
      const partnerEducation = educationData?.id;
      const partner_mother_education_id = parent_mather_educationData;
      const partner_father_education_id = partner_father_educationData;
      const CityInterests = user_data?.Profiles?.[0]?.ProfileDesiredCities.map(
        (item) => item?.City?.id
      );

      console.log('CityInterests', CityInterests);

      form.setFieldsValue({
        minAge: desiredPartner_details?.ProfileDesiredPartners?.[0]?.min_age,
        maxAge: desiredPartner_details?.ProfileDesiredPartners?.[0]?.max_age,
        minHeight:
          desiredPartner_details?.ProfileDesiredPartners?.[0]?.min_height,
        maxHeight:
          desiredPartner_details?.ProfileDesiredPartners?.[0]?.max_height,
        currency:
          desiredPartner_details?.ProfileDesiredPartners?.[0]?.currency_code_id,
        annual_income:
          desiredPartner_details?.ProfileDesiredPartners?.[0]?.annual_income,
        country:
          desiredPartner_details?.ProfileDesiredPartners?.[0]?.country_id,
        city: CityInterests,

        highestEducation: partnerEducation,
        partner_mother_education_id: partner_mother_education_id,
        partner_father_education_id: partner_father_education_id,

        describepartner:
          desiredPartner_details?.ProfileDesiredPartners?.[0]
            ?.partner_description
      });
    }
  }, [user_data]);
  console.log('setFamilyStatus', familyStatus);
  const handleFamilyStatus = (value) => {
    console.log('handle_FamilyStatus', value);
    setFamilyStatus(value);
  };

  const handleFamilyValue = (value) => {
    console.log('handle_FamilyValue', value);
    setFamilyValue(value);
  };

  const handleFamilyType = (id) => {
    console.log('handle_FamilyType', id);
    setFamilyType(id);
  };

  const percent = user_data?.user_score;
  // const conicColors = {
  //   '0%': '#87d068',
  //   '50%': '#ffe58f',
  //   '100%': '#ffccc7'
  // };
  const getStrokeColor = (percent) => {
    if (percent <= 30) return '#ff4d4f'; // Red
    if (percent <= 50) return '#fa8c16'; // Orange
    if (percent <= 80) return '#fadb14'; // Yellow
    return '#52c41a'; // Green
  };
  // const matUserData = localStorage.getItem('MAT-User');
  // const matUserObject = JSON.parse(matUserData);
  // const profile_unique_id = matUserObject?.user_details?.profile_unique_id;

  const handleSelectChange = (value, field) => {
    // setFormData((prev) => ({ ...prev, [field]: value }));
    setCityes((prev) => ({ ...prev, [field]: value }));
  };

  // Custom chip (tag) rendering
  const tagRender = (props) => {
    const { label, closable, onClose } = props;
    return (
      // <Tag
      //   color="rgba(210, 11, 11, 0.11)"
      //   closable={closable}
      //   onClose={onClose}
      //   style={{ marginRight: 5 }}
      // >
      <Tag
        closable={closable}
        onClose={onClose}
        style={{
          marginRight: 5,
          backgroundColor: 'rgba(210, 11, 11, 0.11)',
          color: '#d20b0b',
          borderRadius: '12px',
          padding: '0px 6px'
        }}
      >
        {label}
      </Tag>
    );
  };

  const formatIndianNumber = (num) => {
    console.log('num', num);
    if (!num) return '';
    return new Intl.NumberFormat('en-IN').format(num);
  };

  const handleChange = (e) => {
    console.log('onChange hitting');
    let rawValue = e.target.value.replace(/,/g, ''); // Remove existing commas
    if (!isNaN(rawValue) && rawValue !== '') {
      setAnnualIncome(formatIndianNumber(rawValue));
    } else {
      setAnnualIncome(''); // If input is empty or invalid, clear it
    }
  };
  console.log('setAnnualIncome', annualIncome);

  const getFormattedValue = () => {
    return annualIncome ? formatIndianNumber(annualIncome) : '';
  };

  return (
    <div className={styles.maincontainer}>
      {/* <Form form={form} onFinish={onFinish} layout="vertical"> */}
      <div className={styles.editOuter}>
        {/* <div className={styles.ButtonSet}>
          <button className={styles.primaryButton}>Back</button>
        </div> */}
        <div className={styles.singleContainer}>
          <Row
            gutter={24}
            style={{ width: '100%' }}
            className={styles.aboutimgstyles}
          >
            <Col
              xl={7}
              lg={24}
              md={24}
              sm={24}
              xs={24}
              className={styles.leftspace}
            >
              <div className={styles.leftimgcontainer}>
                {/* <img src={LeftImg} /> */}
                <div className={styles.overlayText}>
                  <h2 className={styles.title}>THE TALE OF</h2>
                  <h1 className={styles.bigTitle}>TWO</h1>
                </div>
              </div>
            </Col>
            <Col
              xl={16}
              lg={24}
              md={24}
              sm={24}
              xs={24}
              className={styles.leftspace}
            >
              <div className={styles.detailSide}>
                <div className={styles.detailName}>
                  <div className={styles.nameflex}>
                    <div className={styles.idname}>
                      <h1 className={styles.dName}> {userName} </h1>
                      {/* <span> {profile_unique_id} </span> */}
                    </div>
                    {/* <div className={styles.matchpercent}>
                      <h6>
                        <span>96%</span> Away to find the right match
                      </h6>
                    </div> */}
                    <Row gutter={[8, 8]} wrap>
                      <Col className={styles.progressname}>
                        <Progress
                          size="small"
                          type="circle"
                          percent={percent}
                          // strokeColor={conicColors}
                          strokeColor={getStrokeColor(percent)}
                        />
                        <h6 className={styles.matchpercent}>
                          away to find your life partner
                        </h6>
                      </Col>
                    </Row>
                  </div>
                  <div className={styles.changes}>
                    {/* <div className={styles.textContainer}>
                      <img
                        src={EditIcon}
                        alt="Edit Profile"
                        className={styles.icon}
                      />
                      <div>Edit</div>
                    </div> */}

                    {/* <div className={styles.vBorder}></div>

                    <div className={styles.textContainer}>
                      <img
                        src={downloadIcon}
                        alt="Download Profile"
                        className={styles.icon}
                      />
                      <div>Download</div>
                    </div> */}
                  </div>
                </div>
                <div>
                  <div className={styles.detailsOuter}>
                    <div className={styles.detailsInner}>
                      <div className={styles.detailsInside}>
                        {/* Tabs Content */}
                        <div className={styles.searchTab}>
                          {Object.keys(routes).map((section) => (
                            <div
                              key={section}
                              className={`${styles.searchTabHeader} ${
                                activeTab === section ? styles.activeTab : ''
                              }`}
                              onClick={() => handleSectionClick(section)}
                            >
                              {section}
                            </div>
                          ))}
                        </div>
                        {/* Tabs Content */}

                        {/*  */}
                        <Form form={form} layout="vertical" onFinish={onFinish}>
                          <Row gutter={24}>
                            {/* Age Range */}
                            <Col
                              xl={12}
                              lg={12}
                              xs={24}
                              sm={24}
                              md={24}
                              style={{ paddingTop: '12px' }}
                            >
                              <Text style={{ color: '#d20b0b' }}>
                                Age Range
                              </Text>
                              <Row gutter={8}>
                                <Col xl={12} lg={12} xs={24} sm={24} md={24}>
                                  <Form.Item
                                    name="minAge"
                                    rules={[
                                      {
                                        required: false,
                                        message: 'Min age is required'
                                      },
                                      {
                                        validator: (_, value) =>
                                          value >= 18 && value <= 100
                                            ? Promise.resolve()
                                            : Promise.reject(
                                                new Error(
                                                  'Min age must be between 18 and 100'
                                                )
                                              )
                                      }
                                    ]}
                                  >
                                    <InputNumber
                                      placeholder="Select min. age"
                                      min={18}
                                      max={100}
                                      onChange={(value) => {
                                        setMinAge(value); // Update state
                                        const maxAge =
                                          form.getFieldValue('maxAge');
                                        if (maxAge < value) {
                                          form.setFieldsValue({
                                            maxAge: value
                                          }); // Reset maxAge to match minAge if lower
                                        }
                                        form.validateFields(['maxAge']); // Revalidate maxAge
                                      }}
                                    />
                                  </Form.Item>
                                </Col>
                                <Col xl={12} lg={12} xs={24} sm={24} md={24}>
                                  <Form.Item
                                    name="maxAge"
                                    dependencies={['minAge']}
                                    rules={[
                                      {
                                        required: false,
                                        message: 'Max age is required'
                                      },
                                      ({ getFieldValue }) => ({
                                        validator(_, value) {
                                          const minAge =
                                            getFieldValue('minAge');
                                          if (!value || value >= minAge) {
                                            return Promise.resolve();
                                          }
                                          return Promise.reject(
                                            new Error(
                                              'Max age must be equal to or greater than Min age'
                                            )
                                          );
                                        }
                                      })
                                    ]}
                                  >
                                    <InputNumber
                                      placeholder="Select max. age"
                                      min={minAge} // ✅ Dynamically update min value
                                      max={100}
                                    />
                                  </Form.Item>
                                </Col>
                              </Row>
                            </Col>

                            {/* Height Range */}
                            <Col
                              xl={12}
                              lg={12}
                              xs={24}
                              sm={24}
                              md={24}
                              style={{ paddingTop: '12px' }}
                            >
                              <Text style={{ color: '#D32F2F' }}>
                                Height Range(in cm)
                              </Text>
                              <Row gutter={8}>
                                {/* <Col xl={12} lg={12} xs={24} sm={24} md={24}>
                                  <Form.Item name="minHeight">
                                    <InputNumber placeholder="Select min. height" />
                                  </Form.Item>
                                </Col>
                                <Col xl={12} lg={12} xs={24} sm={24} md={24}>
                                  <Form.Item name="maxHeight">
                                    <InputNumber placeholder="Select max. height" />
                                  </Form.Item>
                                </Col> */}
                                <Col xl={12} lg={12} xs={24} sm={24} md={24}>
                                  <Form.Item
                                    name="minHeight"
                                    rules={[
                                      {
                                        required: false,
                                        message: 'Min height is required'
                                      },
                                      {
                                        validator: (_, value) =>
                                          value >= 100 && value <= 250
                                            ? Promise.resolve()
                                            : Promise.reject(
                                                new Error(
                                                  'Min height must be between 100 and 250 cm'
                                                )
                                              )
                                      }
                                    ]}
                                  >
                                    <InputNumber
                                      placeholder="Select min. height"
                                      min={100}
                                      max={250}
                                      onChange={(value) => {
                                        setMinHeight(value); // Update state
                                        const maxHeight =
                                          form.getFieldValue('maxHeight');
                                        if (maxHeight < value) {
                                          form.setFieldsValue({
                                            maxHeight: value
                                          }); // Reset maxHeight if it's lower
                                        }
                                        form.validateFields(['maxHeight']); // Revalidate maxHeight
                                      }}
                                    />
                                  </Form.Item>
                                </Col>

                                {/* Max Height */}
                                <Col xl={12} lg={12} xs={24} sm={24} md={24}>
                                  <Form.Item
                                    name="maxHeight"
                                    dependencies={['minHeight']}
                                    rules={[
                                      {
                                        required: false,
                                        message: 'Max height is required'
                                      },
                                      ({ getFieldValue }) => ({
                                        validator(_, value) {
                                          const minHeight =
                                            getFieldValue('minHeight');
                                          if (!value || value >= minHeight) {
                                            return Promise.resolve();
                                          }
                                          return Promise.reject(
                                            new Error(
                                              'Max height must be equal to or greater than Min height'
                                            )
                                          );
                                        }
                                      })
                                    ]}
                                  >
                                    <InputNumber
                                      placeholder="Select max. height"
                                      min={minHeight} // ✅ Dynamically update min value
                                      max={250}
                                      onChange={(value) => {
                                        const maxHeight =
                                          form.getFieldValue('maxHeight');
                                        if (maxHeight < value) {
                                          form.setFieldsValue({
                                            maxHeight: value
                                          }); // Auto-adjust maxHeight if it's smaller
                                        }
                                        form.validateFields(['maxHeight']); // Revalidate maxHeight
                                      }}
                                    />
                                  </Form.Item>
                                </Col>
                              </Row>
                            </Col>

                            <Col
                              xl={12}
                              lg={12}
                              xs={24}
                              sm={24}
                              md={24}
                              style={{ paddingTop: '12px' }}
                            >
                              <Text style={{ color: '#D32F2F' }}>
                                Higher Education
                              </Text>
                              <Form.Item
                                name="highestEducation"
                                // label="Highest Education"
                                className={styles.sectionTitle}
                              >
                                <Select
                                  placeholder="Select higher education"
                                  className={styles.select}
                                  showSearch
                                  optionFilterProp="children"
                                  filterOption={(input, option) =>
                                    option.children
                                      .toLowerCase()
                                      .includes(input.toLowerCase())
                                  }
                                >
                                  {education_list?.length
                                    ? education_list?.map((list, index) => {
                                        return (
                                          <option value={list?.id} key={index}>
                                            {list?.higher_education}
                                          </option>
                                        );
                                      })
                                    : ''}
                                </Select>
                              </Form.Item>
                            </Col>

                            <Col
                              xl={12}
                              lg={12}
                              xs={24}
                              sm={24}
                              md={24}
                              style={{ paddingTop: '12px' }}
                            >
                              <Text className={styles.labels}>
                                Annual Income
                              </Text>
                              <Form.Item
                                // required
                                // label="Phone Number"
                                name="phone"
                                rules={[
                                  {
                                    required: false,
                                    message: 'Please enter select currency'
                                  }
                                ]}
                                className={styles.fullWidthItem}
                              >
                                <Input.Group
                                  compact
                                  className={styles.customInputContainer}
                                >
                                  <Form.Item
                                    name="currency"
                                    noStyle
                                    initialValue={1}
                                  >
                                    <Select
                                      style={{ width: '20%' }}
                                      showSearch
                                      placeholder="Select country code"
                                      className="custom-select"
                                      optionFilterProp="children"
                                      getPopupContainer={(triggerNode) =>
                                        triggerNode.parentNode
                                      } // Ensures correct styling
                                      dropdownStyle={{
                                        borderRadius: '8px'
                                      }} // Apply radius to dropdown
                                      filterOption={(input, option) =>
                                        option.children
                                          .toLowerCase()
                                          .includes(input.toLowerCase())
                                      }
                                    >
                                      {/* {currency_data?.length
                                        ? currency_data?.map((cdata, index) => {
                                            return (
                                              <option
                                                value={cdata?.id}
                                                key={index}
                                              >
                                                {cdata?.currency_code}
                                              </option>
                                            );
                                          })
                                        : ''} */}
                                      {currency_data?.length ? (
                                        currency_data.map((ddata, index) => (
                                          <Select.Option
                                            value={ddata?.id}
                                            key={index}
                                          >
                                            {ddata?.currency_code}
                                          </Select.Option>
                                        ))
                                      ) : (
                                        <Select.Option value={1}>
                                          Default Currency
                                        </Select.Option>
                                      )}
                                    </Select>
                                  </Form.Item>
                                  {/* <span className={styles.divider}>|</span> */}
                                  <Form.Item name="annual_income" noStyle>
                                    <Input
                                      placeholder="Enter annual income"
                                      // type="number"
                                      // value={annialIncome}
                                      value={getFormattedValue()} // Display formatted value
                                      onChange={handleChange}
                                      // maxLength={15}
                                      onBlur={() =>
                                        setAnnualIncome((prev) =>
                                          prev.replace(/,/g, '')
                                        )
                                      } // Ensure raw value is stored
                                      style={{
                                        width: '80%',
                                        marginLeft: '-6px'
                                        // height: '39.5px'
                                      }}
                                    />
                                  </Form.Item>
                                </Input.Group>
                              </Form.Item>
                            </Col>

                            <Col
                              xl={12}
                              lg={12}
                              xs={24}
                              sm={24}
                              md={24}
                              style={{ paddingTop: '12px' }}
                            >
                              <Text style={{ color: '#D32F2F' }}>
                                Mother`s Education
                              </Text>
                              <Form.Item
                                // name="parenteducation"
                                name="partner_mother_education_id"
                                // label="Highest Education"
                                className={styles.sectionTitle}
                              >
                                <Select
                                  placeholder="Select mother`s education"
                                  className={styles.select}
                                  showSearch
                                  optionFilterProp="children"
                                  filterOption={(input, option) =>
                                    option.children
                                      .toLowerCase()
                                      .includes(input.toLowerCase())
                                  }
                                >
                                  {education_list?.length
                                    ? education_list?.map((list, index) => {
                                        return (
                                          <option value={list?.id} key={index}>
                                            {list?.higher_education}
                                          </option>
                                        );
                                      })
                                    : ''}
                                </Select>
                              </Form.Item>
                            </Col>
                            <Col
                              xl={12}
                              lg={12}
                              xs={24}
                              sm={24}
                              md={24}
                              style={{ paddingTop: '12px' }}
                            >
                              <Text style={{ color: '#D32F2F' }}>
                                Father`s Education
                              </Text>
                              <Form.Item
                                name="partner_father_education_id"
                                // label="Highest Education"
                                className={styles.sectionTitle}
                              >
                                <Select
                                  placeholder="Select father`s education"
                                  className={styles.select}
                                  showSearch
                                  optionFilterProp="children"
                                  filterOption={(input, option) =>
                                    option.children
                                      .toLowerCase()
                                      .includes(input.toLowerCase())
                                  }
                                >
                                  {education_list?.length
                                    ? education_list?.map((list, index) => {
                                        return (
                                          <option value={list?.id} key={index}>
                                            {list?.higher_education}
                                          </option>
                                        );
                                      })
                                    : ''}
                                </Select>
                              </Form.Item>
                            </Col>
                            {/* <Col xl={12} lg={12} xs={24} sm={24} md={24} style={{ paddingTop: '12px' }}></Col> */}

                            <Col
                              xl={12}
                              lg={12}
                              xs={24}
                              sm={24}
                              md={24}
                              style={{ paddingTop: '12px' }}
                            >
                              {/* City */}
                              <Text style={{ color: '#D32F2F' }}>City</Text>
                              <Form.Item name="city">
                                <Select
                                  className={styles.customSelectHob}
                                  mode="multiple"
                                  onChange={(value) =>
                                    handleSelectChange(value, 'city')
                                  }
                                  showSearch
                                  placeholder="Select cities"
                                  showArrow={true}
                                  optionFilterProp="children"
                                  filterOption={(input, option) =>
                                    option.children
                                      .toLowerCase()
                                      .includes(input.toLowerCase())
                                  }
                                  tagRender={tagRender} // Add custom tag renderer
                                >
                                  {city_details?.length
                                    ? city_details?.map((city, index) => {
                                        return (
                                          <option value={city?.id} key={index}>
                                            {city?.city}
                                          </option>
                                        );
                                      })
                                    : ''}
                                </Select>
                              </Form.Item>
                            </Col>

                            {/* Family Type */}
                            <Col
                              xl={12}
                              lg={12}
                              xs={24}
                              sm={24}
                              md={24}
                              style={{ paddingTop: '12px' }}
                            >
                              <Form.Item
                                label="Family Type"
                                name="family_type_id"
                                rules={[
                                  {
                                    required: false,
                                    message: 'Please select family type'
                                  }
                                ]}
                              >
                                <div className={styles.selectContainerCountry}>
                                  <div className={styles.checkboxFamily}>
                                    <div className={styles.familyInner}>
                                      <Radio.Group
                                        value={familyType}
                                        onChange={(e) =>
                                          handleFamilyType(e.target.value)
                                        }
                                      >
                                        <Row
                                          gutter={[24]}
                                          className={styles.radiobuttons}
                                        >
                                          {family_Type?.length
                                            ? family_Type.map(
                                                (ftype, index) => (
                                                  <Col span={6} key={index}>
                                                    <Radio value={ftype.id}>
                                                      {ftype.type}
                                                    </Radio>
                                                  </Col>
                                                )
                                              )
                                            : null}
                                        </Row>
                                      </Radio.Group>
                                    </div>
                                  </div>
                                </div>
                              </Form.Item>
                            </Col>

                            <Col span={24} style={{ paddingTop: '12px' }}>
                              <Text style={{ color: '#D32F2F' }}>
                                Family Status
                              </Text>
                              <Form.Item
                                // label="Family Status"
                                name="family_status_id"
                                rules={[
                                  {
                                    required: false,
                                    message: 'Please select family status'
                                  }
                                ]}
                              >
                                <div className={styles.personalTwo}>
                                  <div className={styles.checkboxOuter}>
                                    <div className={styles.checkboxInside}>
                                      <Radio.Group
                                        value={familyStatus}
                                        onChange={(e) =>
                                          handleFamilyStatus(e.target.value)
                                        }
                                      >
                                        <Row
                                          gutter={[24]}
                                          className={styles.radiobuttons}
                                        >
                                          {family_Status?.length
                                            ? family_Status.map(
                                                (fstatus, index) => (
                                                  <Col
                                                    xl={6}
                                                    lg={8}
                                                    md={8}
                                                    sm={12}
                                                    xs={12}
                                                    key={index}
                                                  >
                                                    <Radio value={fstatus.id}>
                                                      {fstatus.status}
                                                    </Radio>
                                                  </Col>
                                                )
                                              )
                                            : null}
                                        </Row>
                                      </Radio.Group>
                                    </div>
                                  </div>
                                </div>
                              </Form.Item>
                            </Col>

                            <Col span={24} style={{ paddingTop: '12px' }}>
                              <Text style={{ color: '#D32F2F' }}>
                                Family Values
                              </Text>
                              <Form.Item
                                // label="Family Values"
                                name="family_values_id"
                                rules={[
                                  {
                                    required: false,
                                    message: 'Please select family values'
                                  }
                                ]}
                              >
                                <div className={styles.personalTwo}>
                                  <div className={styles.checkboxOuter}>
                                    <div className={styles.checkboxInside}>
                                      <Radio.Group
                                        value={familyValue}
                                        onChange={(e) =>
                                          handleFamilyValue(e.target.value)
                                        }
                                      >
                                        <Row
                                          gutter={[24]}
                                          className={styles.radiobuttons}
                                        >
                                          {family_Value?.length
                                            ? family_Value.map(
                                                (fvalue, index) => (
                                                  <Col span={6} key={index}>
                                                    <Radio value={fvalue.id}>
                                                      {fvalue.values}
                                                    </Radio>
                                                  </Col>
                                                )
                                              )
                                            : null}
                                        </Row>
                                      </Radio.Group>
                                    </div>
                                  </div>
                                </div>
                              </Form.Item>
                            </Col>

                            <Col span={24} style={{ paddingTop: '12px' }}>
                              <Text style={{ color: '#D32F2F' }}>
                                Describe your future partner
                              </Text>
                              <Form.Item name="describepartner">
                                <TextArea
                                  placeholder="Write a few words to describe the person who might move through life's rhythm with you!"
                                  rows={6}
                                  maxLength={1000}
                                  style={{
                                    width: '100%',
                                    borderColor: '#D32F2F',
                                    fontFamily: 'Teachers'
                                  }}
                                />
                              </Form.Item>
                            </Col>
                          </Row>

                          <br />
                          <Form.Item>
                            <Button
                              type="primary"
                              htmlType="submit"
                              className={styles.submitbutton}
                              loading={editpartnerdetailsloading}
                              disabled={editpartnerdetailsloading}
                            >
                              Save & Next
                            </Button>
                          </Form.Item>
                        </Form>
                        {/*  */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </div>
      {/* </Form> */}
    </div>
  );
};

export default Edit;
